const ATTENDANCE_SUMMARY_TABLE_READY = "attendance-summary-table-ready"
const SEARCH_TEXT_STATE = "attendance-summary-table-search-text-state"
const ROWS_PER_PAGE_STATE = "attendance-summary-table-rows-per-page-state"
const PAGINATION_STATE = "attendance-summary-table-pagination-state"


const PREVIOUS_STORE_FILTER_START_DATE = "attendance-summary-previous-start-date"
const PREVIOUS_STORE_FILTER_END_DATE = "attendance-summary-previous-end-date"
//const PREVIOUS_STORE_FILTER_CITY = "attendance-summary-previous-city"

const initialState = {
    isAttendanceSummaryReady: true,
    attendanceSummary: {},

    previousFilterStartDate: "",
    previousFilterEndDate: "",

    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ATTENDANCE_SUMMARY_TABLE_READY:
            return Object.assign({}, state, { isAttendanceSummaryReady: action.payload })       


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)


        case PREVIOUS_STORE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_STORE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        default:
        return state
    
    }

}

export function attendanceSummaryTableReady(data) {
    return {
        type: ATTENDANCE_SUMMARY_TABLE_READY,
        payload: data
    }
}




export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}


export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_END_DATE,
        payload:fiter_val
    }
}




// WEBPACK FOOTER //
// ./src/modules/Attendance Summary/redux/attendance_summary.js